import React from "react";
import { Lock } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useLeadSubmission } from "@/hooks/useLeadSubmission";
import { DocumentUpload } from "@/components/portal/DocumentUpload";
import { LeadForm } from "@/components/portal/LeadForm";
import { SuccessPanel } from "@/components/portal/SuccessPanel";

export const Portal = () => {
  const { t, lang } = useLanguage();
  const {
    files, form, errors, submitting, success,
    addFiles, removeFile, setField, submit, reset,
  } = useLeadSubmission({ t, lang });

  return (
    <section id="portal" className="relative bg-[var(--brand-offwhite)] py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.18em] text-[var(--brand-burgundy)]">
            <Lock className="h-3.5 w-3.5" /> {t.portal.eyebrow}
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight text-[var(--brand-navy)] sm:text-4xl">
            {t.portal.title}
          </h2>
          <p className="mt-3 text-[var(--muted-ink)]">{t.portal.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-5xl overflow-hidden rounded-3xl border border-[color:var(--border-subtle)] bg-white shadow-[var(--shadow-float)]">
          {success ? (
            <SuccessPanel onReset={reset} />
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <DocumentUpload files={files} onAddFiles={addFiles} onRemoveFile={removeFile} />
              <LeadForm form={form} errors={errors} submitting={submitting} onFieldChange={setField} onSubmit={submit} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Portal;
